import clsx from 'clsx';
import { observer } from 'mobx-react';
import { ReactElement } from 'react';
import { T } from '../../../../../../../../../../Translations';
import CopyToClipboardStore from '../../../../../../../../../CopyToClipboard/Store';

export interface Props {
  children: ReactElement;
  store: CopyToClipboardStore;
  copyText: string;
}

const clickHandler = (
  navigator: Navigator,
  copyToClipboardStore: CopyToClipboardStore,
  copyText: string,
) => {
  navigator.clipboard.writeText(copyText);
  return copyToClipboardStore.copying();
};

function Button({ store, copyText, children }: Props) {
  return (
    <button
      className={clsx(
        'border rounded border-teal-600 w-full text-teal-600 font-medium py-3 text-sm flex',
        'justify-center items-center mt-3',
      )}
      onClick={() => clickHandler(navigator, store, copyText)}
      data-intercom-target="builder-copy-collection-url-to-share-with-participants-button"
    >
      {children}
      <T kind="Copy Collection URL to Share with Participants" />
    </button>
  );
}

export default observer(Button);
